var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};




import Cloudinary from 'cloudinary';



export var CloudinaryUploader = ( function ( _super ) {
    __extends( CloudinaryUploader, _super );
    function CloudinaryUploader ( ) {
        this.cloudinary = _super;
        this.cloud_name = 'dkod53hsv';
	    this.api_key = '334154286362475';
	    this.api_secret = 'ioqdy-2BTs36JnmuzTCqkwkEILw';
	    this.cloudinary.config({ 
	      cloud_name: this.cloud_name, 
	      api_key: this.api_key, 
	      api_secret: this.api_secret 
	    });
    }
    CloudinaryUploader.prototype.log = function ( ) {
    };
    CloudinaryUploader.prototype.upload = function ( image_url, opts, cb ) {
        this.cloudinary.v2.uploader.upload( image_url, opts, function ( error, result ) { cb( result ) } );
    };
    CloudinaryUploader.prototype.destroy = function ( public_id, cb ) {
	    this.cloudinary.v2.uploader.destroy( public_id, {invalidate: true }, function ( error, result ) { cb( result ) } );
    };
    
    return CloudinaryUploader;
} ( Cloudinary ) );


// WEBPACK FOOTER //
// /root/anvel/angular/app/services/cloudinary-uploader.service.ts